export { default as Input } from './Input';
export type { InputProps, InputVariant } from './types';
